import React from 'react'

import type { SelectOption } from '@fourthwall/components'
import { Input, Select } from '@fourthwall/components'
import type { useFormik } from '@fourthwall/utils/dist/formik'

import type {
  FormValues,
  LikesReceivedRule as LikesReceivedRuleType,
} from '../../hooks/useBadgeForm/types'
import { FormFields } from '../../hooks/useBadgeForm/types'
import { RuleLayout } from '../RuleLayout'

type Props = {
  form: ReturnType<typeof useFormik<FormValues>>
  options: SelectOption[]
}

export const LikesReceivedRule = ({ form, options }: Props) => (
  <RuleLayout
    top={
      <Select
        value={'LikesReceived' satisfies LikesReceivedRuleType['type']}
        label="Requirement to earn badge"
        options={options}
        onValueChange={(value) => {
          const newRules = form.values.rules.map((rule) =>
            rule.type === 'LikesReceived' ? { type: value } : rule,
          )

          form.setFieldValue(FormFields.rules, newRules)
        }}
      />
    }
    bottom={
      <>
        <Input {...form.getFieldProps(FormFields.likesReceivedMin)} label="Min. likes number" />
        <Input
          {...form.getFieldProps(FormFields.likesReceivedMax)}
          label="Max. likes number"
          suggestion="Leave empty for infinite"
        />
      </>
    }
    onRemove={() => {
      form.setFieldValue(
        FormFields.rules,
        form.values.rules.filter(
          (rule) => rule.type !== ('LikesReceived' satisfies LikesReceivedRuleType['type']),
        ),
      )
    }}
  />
)
